import { useEffect, useState } from 'react'
import { SellerParams } from '../services/sellersService/seller'
import { useInfiniteQuery } from '@tanstack/react-query'
import { sellerService } from '../services/sellersService'
import { useToast } from '../../view/components/ui/use-toast'
import { UserRoleEnum } from '../services/usersService/user'
import { useAuth } from './useAuth'

interface useSellersProps {
  initialLimit: number
  role?: UserRoleEnum
}

export const useSellers = ({ initialLimit, role }: useSellersProps) => {
  const { user } = useAuth()
  const [params, setParams] = useState<SellerParams>({})
  const [isInitialFetch, setIsInitialFetch] = useState(true)

  const handleSellersData = async ({ pageParam = 0 }) => {
    const response = await sellerService.seller({
      ...params,
      skip: pageParam,
      limit: isInitialFetch ? initialLimit : 30,
      role,
    })

    setIsInitialFetch(false)
    return response
  }

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
    isError,
  } = useInfiniteQuery({
    queryKey: ['Allsellers', params, role, user?._id],
    queryFn: handleSellersData,
    getNextPageParam: (lastPage) => {
      if (
        lastPage.pagination.skip + lastPage.pagination.limit ===
        lastPage.pagination.total / lastPage.pagination.limit
      ) {
        return null
      }
      return lastPage.pagination.skip + lastPage.pagination.limit
    },
    initialPageParam: undefined,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  }
}
